/* eslint-disable no-var */
/* eslint-disable vars-on-top */
/* eslint-disable no-undef */
import { useCallback } from 'react';

declare global {
  interface Scheduler {
    yield: () => Promise<void>;
  }

  var scheduler: Scheduler | undefined;
}

function useYieldToNextPaint() {
  return useCallback(() => {
    return new Promise<void>((resolve) => {
      if (globalThis?.scheduler?.yield) {
        (globalThis.scheduler as Scheduler)?.yield()?.then(() => resolve());
      } else if (typeof requestAnimationFrame === 'function') {
        requestAnimationFrame(() => {
          setTimeout(resolve, 0);
        });
      } else {
        setTimeout(resolve, 16);
      }
    });
  }, []);
}

export default useYieldToNextPaint;
